import Plugin from "@ckeditor/ckeditor5-core/src/plugin";
import CitationsReOrderCommand from "./citationsreordercommand";

export default class CitationsReOrderEditing extends Plugin {
  init() {
    const editor = this.editor;
    editor.commands.add(
      "citationsreorder",
      new CitationsReOrderCommand(editor)
    );
  }
}
